import { DialectSdkFactory } from '../internal/sdk/sdk-factory';
export class Dialect {
    static sdk(configProps, blockchainSdkFactory) {
        return new DialectSdkFactory(configProps, blockchainSdkFactory).create();
    }
}
export class BlockchainSdk {
}
export class DialectSdk {
}
//# sourceMappingURL=sdk.interface.js.map